import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../context/AuthProvider";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import Messages from "../../../constants/Messages";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { Skeleton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import AddGroup from "./AddGroup";
import EditGroup from "./EditGroup";
import Button from "../recharge/Button";
import useKeyboardTableNavigation from "../../../constants/useKeyboardTableNavigation";
import DeleteModal from "../../../constants/DeleteModal";
import CustomerView from "./SupplierView";
import AddSupplier from "./AddSupplier";
import EditSupplier from "./EditSupplier";
import uRLs from "../../../utils/baseUtils";
import ProductSearchList from "../../../constants/ProductSearchList";
import { AddIcon, CircleIcon, CustomersIcon, DownloadIcon, EditIcon, RefreshIcon, SearchIcon, ShowIcon, SortDownIcon, SpreadSheetIcon, UploadIcon } from "../../../constants/Icons";

const Supplier = ({ isActive }) => {
  const [isBtnLoading, setBtnLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isCustomerData, setCustomerData] = useState([]);
  const [isGroupLoading, setIsGroupLoading] = useState(false);
  const [selectedGroupDetails, setSelectedGroupDetails] = useState(null);
  const searchInputRef = useRef(null);
  const navigate = useNavigate();
  const customerSuggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);
  const [addGroupload, setAddGroupLoad] = useState(false);
  const { updateSettings, isUser } = useAuth();
  const [numberSuggest, setNumberSuggest] = useState([]);

  const [isSearchTerm, setSearchTerm] = useState("");
  const [customerSuggestions, setCustomerSuggestions] = useState([]);
  const [selectedCustomerPhone, setSelectedCustomerPhone] = useState("");
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1); // -1 = none selected
  const [error, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [hasSearched, setHasSearched] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 10;

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [isDeleteData, setDeleteData] = useState(null);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [groupName, setGroupName] = useState([]);
  const [addNewGroupOpen, setNewGroupOpen] = useState(false);
  const [editGroupOpen, setEditGroupOpen] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const {
    permission,
    hasPermission,
    customerGroups,
    blockedPermissions,
    viewOption,
    globelPopupOpen,
  } = usePermission();
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const [selectAll, setSelectAll] = useState(false);
  const [selectMy, setSelectMy] = useState(false);
  const [newGroupName, setNewGroupName] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState({
    field: "createdAt",
    order: "desc",
  });

  // const numberSuggest=[
  //   {number:"998211212",id:1},{number:"998211213",id:2},{number:"998211214",id:3},{number:"998211215",id:4},{number:"998211216",id:5},{number:"998211217",id:6},
  // ]
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const handleNewGroupClose = () => {
    setNewGroupOpen(false);
  };
  const handleEditGroupClose = () => {
    setEditGroupOpen(false);
  };
  const handleEditGroupOpen = () => {
    if (
      hasPermission("SUPPLIER", "SUPPLIER:updateSupplierGroup") ||
      permission === undefined
    ) {
      setEditGroupOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };
  const handleNewGroupOpen = () => {
    if (
      hasPermission("SUPPLIER", "SUPPLIER:addSupplierGroup") ||
      permission === undefined
    ) {
      setNewGroupOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleLink = () => {
    const navigatelist = "/supplier";
    navigate("/supplier-upload", { state: { navigatelist } });
  };

  const handleListCustomer = async (
    page = 0,
    term = "",
    sortbyField = "createdAt",
    sortOrder = "desc",
  ) => {
    if (isLoading) return;
    try {
      if (!checkNetwork()) return;
      setIsLoading(true);
      // const data = { searchtxt: term, pageno: page + 1, limit: perPage };
      let response;
      if (isUser.stype === "MAIN") {
        response = await AxiosInstance.get(
          `module/supplier/all?pageno=${
            page + 1
          }&limit=${perPage}&searchtxt=${term}&sortby=${sortOrder}&sortbyField=${sortbyField}`,
        );
      } else {
        response = await AxiosInstance.get(
          `module/supplier?pageno=${
            page + 1
          }&limit=${perPage}&searchtxt=${term}&sortby=${sortOrder}&sortbyField=${sortbyField}`,
        );
      }
      const results = response.data.results || [];
      setCustomerData(results);
      if (results.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // const handleCustomerNumbersuggestion = async () => {
  //   if (!checkNetwork()) return;
  //   try {
  //     const response = await AxiosInstance.get(
  //       "module/supplier/suggestion/phone",
  //     );
  //     const result = response.data.results;
  //     setNumberSuggest(result);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const addNewCustomNumber = (phone) => {
    const trimmed = phone?.trim();

    if (!trimmed) return; // ignore empty/whitespace input

    const exists = numberSuggest?.some(
      (s) => s.phone?.toLowerCase() === trimmed?.toLowerCase(),
    );

    if (!exists) {
      setNumberSuggest((prev) => [
        { _id: Date.now().toString(), phone: trimmed },
        ...prev,
      ]);
    }
  };

  const handleSearch = (term) => {
    if (
      hasPermission("SUPPLIER", "SUPPLIER:search") ||
      permission === undefined
    ) {
      setSearchTerm(term);
      setHasSearched(true);
      setSelectedCustomerPhone("");

      if (!term?.trim()) {
        setCustomerSuggestions([]);
        if (selectedGroupId) {
          // handleGroupList(0, " ");
        } else {
          handleListCustomer(0, "");
        }
        setCurrentPage(0);
        return;
      }

      //  Clear previous debounce timer
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      //  Cancel previous API request if still running
      if (controllerRef.current) {
        controllerRef.current.abort();
      }

      debounceTimerRef.current = setTimeout(async () => {
        try {
          if (!checkNetwork()) return;
          setSuggestionLoading(true);

          // Create new AbortController for this request
          controllerRef.current = new AbortController();

          let response;
          if (isUser.stype === "MAIN") {
            response = await AxiosInstance.get(
              `module/supplier/search?searchtxt=${term?.toLowerCase()}`,
              { signal: controllerRef.current.signal },
            );
          } else {
            response = await AxiosInstance.get(
              `module/supplier?searchtxt=${term?.toLowerCase()}`,
              { signal: controllerRef.current.signal },
            );
          }
          setCustomerSuggestions(response.data.results || []);
        } catch (error) {
          if (error.name !== "CanceledError" && error.name !== "AbortError") {
            handleError(error, showAlert);
          }
        } finally {
          setSuggestionLoading(false);
        }
      }, 200);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleSearchFind = () => {
    const currentInputValue = searchInputRef.current?.value || "";
    setSearchTerm(currentInputValue);
    setSelectedCustomerPhone("");
    if (!currentInputValue?.trim()) {
      handleListCustomer(0, "");
    } else {
      handleListCustomer(0, currentInputValue);
    }
    setCustomerSuggestions([]);
    setHasSearched(false);
    setCurrentPage(0);
  };

  const handleSelectCustomer = (customer) => {
    const phone = customer.phone;
    setSearchTerm(phone);
    setSelectedCustomerPhone(phone);
    setCustomerSuggestions([]);
    setHasSearched(false);
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
    handleView(customer);
    // handleListCustomer(0, phone);
    // setCurrentPage(0);
  };

  const handleOutsideClick = (e) => {
    if (
      customerSuggestionsRef.current &&
      !customerSuggestionsRef.current.contains(e.target)
    ) {
      setCustomerSuggestions([]);
      setHasSearched(false);
    }
  };

  const handleOpenModal = () => {
    if (hasPermission("SUPPLIER", "SUPPLIER:add") || permission === undefined) {
      setModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleView = (customer) => {
    // console.log(customer);
    setSelectedCustomerId(customer._id); // pass the customer id
    setViewModalOpen(true);
    // console.log("view");
  };

  const handleAdd = async (newData, resetForm) => {
    try {
      if (!checkNetwork()) return;
      const data = {
        ...newData,
        ...(newData.contactPersonname?.trim() ||
        newData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(newData.contactPersonname?.trim() && {
                  name: newData.contactPersonname,
                }),
                ...(newData.contactPersonNumber?.trim() && {
                  number: newData.contactPersonNumber,
                }),
              },
            }
          : {}),
      };
      if (!data.groupid) {
        delete data.groupid;
      }
      const response = await AxiosInstance.post(`module/supplier`, data);
      showAlert("success", Messages.SUCCESS.SUPPLIER_ADDED);
      // await handleListCustomer(0);
      const result = response.data.results;
      if (result.name !== newData.name) {
        showAlert(
          "warning",
          `The phone number"${result.number}" already exists .`,
        );
        // handleCloseModal();
        return true;
      }
      let isLocalDuplicate = false;

      setCustomerData((prev) => {
        if (prev.some((it) => it.name === result.name)) {
          isLocalDuplicate = true;
          return prev;
        } else {
          let newArray = [result, ...prev];

          if (newArray.length > 10) {
            return newArray.slice(0, -1);
          } else {
            return newArray;
          }
        }
      });
      if (isLocalDuplicate) {
        showAlert(
          "warning",
          `The phone number "${result.phone}" already exists in the list.`,
        );
      } else {
        showAlert("success", Messages.SUCCESS.SUPPLIER_ADDED);
        setTotalItems((prevCount) => prevCount + 1);
      }
      resetForm();
      // setCurrentPage(0);
      handleCloseModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //   fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    }
  };

  const openEditModal = (cItem) => {
    if (blockedPermissions("SUPPLIER:view") || permission === undefined) {
      setEditData(cItem);
      setEditModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const closeEditModal = () => {
    setEditData(null);
    setEditModalOpen(false);
  };

  const hanleUpdateCustomer = (data) => {
    setCustomerData((prevCustomerData) =>
      prevCustomerData?.map((customer) =>
        customer?._id === data?._id ? data : customer,
      ),
    );
  };

  const handleUpdte = async (updatedData) => {
    console.log("updatedData", updatedData);
    const editableKeys = [
      "name",
      "number",
      "email",
      "addressline1",
      "addressline2",
      "city",
      "district",
      "state",
      "pincode",
      "country",
      "gstnumber",
      "pannumber",
      "cinnumber",
      "referenceid",
      "isPayLater",
      "groupid",
      "website",
      "fssai",
      "tradeName",
      "nickname",
      "contactPersonname",
      "contactPersonNumber",
    ];

    let hasChange = false;
    for (const key of editableKeys) {
      const originalValue = String(isEditData[key] || "");
      const updatedValue = String(updatedData[key] || "");
      if (originalValue !== updatedValue) {
        hasChange = true;
        break;
      }
    }

    if (!hasChange) {
      showAlert("warning", "No changes detected.");
      return false;
    }

    try {
      if (!checkNetwork()) return;
      const data = {
        ...updatedData,
        ...(updatedData.contactPersonname?.trim() ||
        updatedData.contactPersonNumber?.trim()
          ? {
              contactPerson: {
                ...(updatedData.contactPersonname?.trim() && {
                  name: updatedData.contactPersonname,
                }),
                ...(updatedData.contactPersonNumber?.trim() && {
                  number: updatedData.contactPersonNumber,
                }),
              },
            }
          : {}),
        customerid: updatedData._id,
      };
      const response = await AxiosInstance.patch(
        `module/supplier/${updatedData._id}`,
        data,
      );
      showAlert("success", Messages.SUCCESS.SUPPLIER_UPDATED);
      const updatedCustomer = response.data.results;
      const updatedCustomerId = updatedCustomer?._id;
      const originalGroupId = isEditData?.groupid || "";
      const newGroupId = updatedData.groupid || "";
      const groupIdChanged = originalGroupId !== newGroupId;
      if (groupIdChanged) {
        setTotalItems((prevCount) => prevCount + 1);
      }
      setCustomerData((prevCustomerData) => {
        // const originalCustomer = prevCustomerData.find(
        //     (customer) => customer._id === updatedCustomerId
        // );
        // const originalGroupId = originalCustomer?.groupid || "";
        // const newGroupId = updatedCustomer?.groupid || "";

        // const groupIdChanged = originalGroupId !== newGroupId;

        if (groupIdChanged) {
          const filteredData = prevCustomerData.filter(
            (customer) => customer._id !== updatedCustomerId,
          );

          return [updatedCustomer, ...filteredData];
        } else {
          return prevCustomerData.map((customer) =>
            customer._id === updatedCustomerId ? updatedCustomer : customer,
          );
        }
      });
      closeEditModal();
      return true;
    } catch (error) {
      if (
        error.response &&
        error.response.status === 409 &&
        error.response.data &&
        error.response.data.code === "DUPLICATE_ENTRY"
      ) {
        const errorMessage = error.response.data.message;
        let fieldError = {};

        // if (errorMessage.includes("ReferenceId already exists")) {
        //   fieldError.referenceid = "Reference ID already exists .";
        // }
        if (errorMessage.includes("GST number already exists")) {
          fieldError.gstnumber = "GST number already exists.";
        }

        if (Object.keys(fieldError).length > 0) {
          setErrors((prev) => ({ ...prev, ...fieldError }));
        } else {
          handleError(error, showAlert);
        }

        return false;
      } else {
        handleError(error, showAlert);
        return false;
      }
    }
  };

  const handleNewGroupSet = (results) => {
    setGroupName((prev) => [
      { ...results },
      ...(Array.isArray(prev) ? prev : []),
    ]);
  };

  // const handleCustomerGroupAdd = async (groupName) => {
  //   console.log(groupName);
  //   setAddGroupLoad(true);
  //   try {
  //     const data = {
  //       name: groupName,
  //     };
  //     const response = await AxiosInstance.post("module/customer/group", data);
  //     const results = response.data.results;
  //     //  setGroupName(results);
  //     setGroupName((prev) => [
  //       { ...results },
  //       ...(Array.isArray(prev) ? prev : []),
  //     ]);
  //     updateSettings({
  //       customerGroups: [
  //         { ...results },
  //         ...(Array.isArray(customerGroups) ? customerGroups : []),
  //       ],
  //     });
  //     showAlert("success", "Customer Group Added Successfull");
  //     setAddGroupLoad(false);
  //     handleNewGroupClose();
  //     setNewGroupName(results);
  //     handleOpenModal();
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setAddGroupLoad(false);
  //   }
  // };
  // const handleCustomerGroupEdit = async (groupName, id) => {
  //   setAddGroupLoad(true);
  //   try {
  //     const data = {
  //       name: groupName,
  //     };
  //     const response = await AxiosInstance.patch(
  //       `module/customer/group/${id}`,
  //       data
  //     );
  //     const results = response.data.results;
  //     //  setGroupName(results);
  //     setGroupName((prev) => {
  //       if (!Array.isArray(prev)) return [{ ...results }]; // safeguard

  //       return prev.map((g) =>
  //         g._id === results._id ? { ...g, ...results } : g
  //       );
  //     });
  //     setSelectedGroupDetails(results);
  //     setAddGroupLoad(false);
  //     showAlert("success", "Customer Group Updated");
  //     handleEditGroupClose();
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setAddGroupLoad(false);
  //   }
  // };

  // const handleGroupList = async (page = 0, term = "") => {
  //   setIsGroupLoading(true);
  //   try {
  //     const response = await AxiosInstance.get(
  //       `module/customer/group/list?pageno=${page + 1}&limit=${perPage}`
  //     );
  //     const results = response.data.results;
  //     setGroupName(results);
  //     setIsGroupLoading(false);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setIsGroupLoading(false);
  //   }
  // };

  const handleSelectAll = async () => {
    setSelectAll(true);
    setCustomerData("");
    setSelectedGroupId(null);
    setSelectedGroupDetails("");
    setSearchTerm("");
    setCurrentPage(0);
    await handleListCustomer(0, "");
  };

  const handleSelectMy = async () => {
    setSelectMy(true);
    setCustomerData("");
    setSelectedGroupId(null);
    setSelectedGroupDetails("");
    setSearchTerm("");
    setCurrentPage(0);
    await handleListCustomer(0, "");
  };

  // const handleGroupCustomerList = async (
  //   item,
  //   page = 0,
  //   sortbyField = "createdAt",
  //   sortOrder = "desc"
  // ) => {
  //   setIsLoading(true);

  //   try {
  //     const response = await AxiosInstance.get(
  //       `module/customer/grouped/${item._id}?pageno=${
  //         page + 1
  //       }&limit=${perPage}&sortby=${sortOrder}&sortbyField=${sortbyField}`
  //     );
  //     const results = response.data.results;
  //     setCustomerData(results);
  //     setSelectedGroupId(item._id);
  //     setSelectedGroupDetails(item);

  //     isUser.stype === "MAIN" ? setSelectAll(false) : setSelectMy(false);

  //     if (results.length === 0) {
  //       setTotalPages(0);
  //       setTotalItems(0);
  //       setCurrentPage(0);
  //     } else {
  //       setTotalPages(response.data.totalPages || 0);
  //       setTotalItems(response.data.totalItems || 0);
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  const openDeleteModal = (cItem) => {
    if (
      hasPermission("SUPPLIER", "SUPPLIER:delete") ||
      permission === undefined
    ) {
      setDeleteData(cItem);
      setDeleteModalOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleDeleteCustomer = (data) => {
    setCustomerData((prevData) =>
      prevData?.filter((customer) => customer._id !== data?._id),
    );
    setTotalItems((prev) => prev - 1);
  };

  const handleDelete = async () => {
    try {
      if (!checkNetwork()) return;
      // const data = { customerid: isDeleteData._id };
      await AxiosInstance.delete(`module/supplier/${isDeleteData._id}`);
      showAlert("success", Messages.SUCCESS.CUSTOMER_DELETED);
      setCustomerData((prevData) =>
        prevData.filter((customer) => customer._id !== isDeleteData._id),
      );

      setTotalItems((prev) => prev - 1);

      // const newTotal = totalItems - 1;
      // const newTotalPages = Math.ceil(newTotal / perPage);

      // if (isCustomerData.length === 1 && currentPage > 0) {
      //   setCurrentPage((prev) => prev - 1);
      //   await handleListCustomer(currentPage - 1, isSearchTerm);
      // } else {
      //   await handleListCustomer(currentPage, isSearchTerm);
      // }

      // setTotalItems(newTotal);
      // setTotalPages(newTotalPages);
      setDeleteModalOpen(false);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const exportToCSV = () => {
    if (!isCustomerData?.length > 0) {
      showAlert("warning", "No data available to export");
      return;
    }

    // 1. Headers
    const headers = `S No,Name,Phone,Email,Address,District,State,Pincode,Country,State Code,GST Number, Cin Number,Pan Number,Status`;

    const clean = (val) => (val ?? "").toString().replace(/[\r\n;]/g, " ");

    // 2. Rows
    const quote = (val) => `"${clean(val)}"`;

    const rows = isCustomerData
      .map((item, index) => {
        const fullAddress = `${item.addressline1 || ""} ${
          item.addressline2 || ""
        }`;
        const row = [
          quote(currentPage * perPage + index + 1),
          quote(item.name),
          quote("+91" + item.phone),
          quote(item.email),
          quote(fullAddress),
          quote(item.district),
          quote(item.state),
          quote(item.pincode),
          quote(item.country),
          quote(item.statecode),
          quote(item.gstnumber),
          quote(item.cinnumber),
          quote(item.pannumber),
          quote(item.status),
        ];
        return row.join(",");
      })
      .join("\n");

    // 5. Combine everything
    const csvContent = [headers, rows].join("\n");

    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `SupplierList_${formatDate(new Date())}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "bg-label-success";
      case "inactive":
        return "bg-label-danger";
      default:
        return "bg-label-secondary";
    }
  };

  useKeyboardTableNavigation({
    searchTerms: isSearchTerm,
    suggestions: customerSuggestions,
    modals: {
      isModalOpen,
      isViewModalOpen,
      isEditData,
      isDeleteModalOpen,
      addNewGroupOpen,
      editGroupOpen,
      globelPopupOpen,
    },
    // onEnter: handleView,
  });
  // useEffect(() => {
  //   const handleArrowAndEnter = (e) => {
  //     // Only handle when search term is empty or suggestions list is empty
  //     if (!(isSearchTerm.trim() === "" || customerSuggestions.length === 0))
  //       return;

  //     if (
  //       isModalOpen ||
  //       isViewModalOpen ||
  //       isEditData ||
  //       isDeleteModalOpen ||
  //       addNewGroupOpen ||
  //       editGroupOpen ||
  //       globelPopupOpen
  //     )
  //       return;

  //     if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

  //     e.preventDefault();

  //     const tableRows = Array.from(document.querySelectorAll("table tbody tr"));
  //     if (!tableRows.length) return;

  //     const currentRow = document.activeElement.closest("tr");
  //     let currentIndex = tableRows.indexOf(currentRow);

  //     // Handle Enter key
  //     if (e.key === "Enter") {
  //       if (currentIndex >= 0) {
  //         const item = tableRows[currentIndex].dataset.item
  //           ? JSON.parse(tableRows[currentIndex].dataset.item)
  //           : null;

  //         if (item) handleView(item);
  //       }
  //       return;
  //     }

  //     // Virtual -1: no row focused yet
  //     if (currentIndex === -1) {
  //       if (e.key === "ArrowDown") {
  //         tableRows[0].tabIndex = 0;
  //         tableRows[0].focus();
  //       } else if (e.key === "ArrowUp") {
  //         tableRows[tableRows.length - 1].tabIndex = 0;
  //         tableRows[tableRows.length - 1].focus();
  //       }
  //       return;
  //     }

  //     // Remove tabIndex from current row
  //     currentRow.tabIndex = -1;

  //     // Calculate next/previous index
  //     let nextIndex =
  //       e.key === "ArrowDown"
  //         ? (currentIndex + 1) % tableRows.length
  //         : (currentIndex - 1 + tableRows.length) % tableRows.length;

  //     const nextRow = tableRows[nextIndex];
  //     nextRow.tabIndex = 0;
  //     nextRow.focus();
  //   };

  //   window.addEventListener("keydown", handleArrowAndEnter);
  //   return () => window.removeEventListener("keydown", handleArrowAndEnter);
  // }, [
  //   isSearchTerm,
  //   customerSuggestions,
  //   isModalOpen,
  //   isViewModalOpen,
  //   isEditData,
  //   isDeleteModalOpen,
  //   addNewGroupOpen,
  //   editGroupOpen,
  //   globelPopupOpen,
  // ]);

  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && customerSuggestions[activeIndex]) {
        e.preventDefault();
        handleSelectCustomer(customerSuggestions[activeIndex]);
      } else {
        e.preventDefault();
        handleSearchFind();
      }
      if (isSearchTerm.trim() === "" || customerSuggestions.length === 0) {
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();

      if (isSearchTerm.trim() === "" || customerSuggestions.length === 0) {
      }

      setActiveIndex((prev) =>
        prev < customerSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : customerSuggestions.length - 1,
      );
    }
  };

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // useEffect(() => {
  //   searchInputRef.current?.focus();
  //   // handleGroupList();
  //   isUser.stype === "MAIN" ? setSelectAll(true) : setSelectMy(true);
  // }, []);

  // useEffect(() => {
  //   if (selectedGroupId === null) {
  //     if (
  //       hasPermission("CUSTOMER", "CUSTOMER:list") ||
  //       permission === undefined
  //     ) {
  //       handleListCustomer(currentPage, isSearchTerm);
  //     } else {
  //       showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (!isActive) return;

    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);

    return () => clearTimeout(timer);
  }, [isActive]);

  const handleFilterChange = (e) => {
    const [field, order] = e.target.value.split("-");
    setSelectedFilter({ field, order });
  };

  // useEffect(() => {
  //   handleCustomerNumbersuggestion();
  // }, []);
  useEffect(() => {
    if (selectedGroupId) {
      // handleGroupCustomerList(
      //   selectedGroupDetails,
      //   currentPage,
      //   selectedFilter.field,
      //   selectedFilter.order
      // );
    } else {
      handleListCustomer(
        currentPage,
        isSearchTerm,
        selectedFilter.field,
        selectedFilter.order,
      );
    }
  }, [selectedFilter]);

  const handleRefresh = async () => {
    if (selectedGroupId) {
      // await handleGroupCustomerList(
      //   selectedGroupDetails,
      //   currentPage,
      //   selectedFilter.field,
      //   selectedFilter.order,
      // );
    } else {
      await handleListCustomer(
        currentPage,
        isSearchTerm,
        selectedFilter.field,
        selectedFilter.order,
      );
    }
  };

  // const handleGroupChange = (group) => {
  //   setCurrentPage(0);
  //   setSelectedGroupDetails(group);
  //   if (group && group._id) {
  //     handleGroupCustomerList(group);
  //   } else {
  //     isUser.stype === "MAIN" ? setSelectAll(true) : setSelectMy(true);

  //     setSelectedGroupId(null);
  //     setSelectedGroupDetails("");
  //     handleListCustomer();
  //   }
  // };
  const isReferenceIdVisible = viewOption("customerSettings", "isReferenceId");
  const totalSkeletonColumns = 5 + (isReferenceIdVisible ? 1 : 0);
  return (
    <div className="page-wrapper">
      <div className="page-content">
        <div className="row">
          {/* <div className="col-lg-2">
            <div className="card">
              <div className="card-header px-3 py-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                <div className="breadcrumb-title pe-3">Supplier Group</div>
              </div>
              {isBtnLoading ? (
                [...Array(4)].map((_, index) => (
                  <ul
                    className="list-group list-group-flush radius-10"
                    key={index}
                  >
                    <li className="cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border">
                      <Skeleton
                        variant="rectangular"
                        className="rounded"
                        width="100%"
                      />
                    </li>
                  </ul>
                ))
              ) : (
                <div className="card-body mb-0">
                  <ul className="list-group list-group-flush radius-10">
                    {isUser.stype === "MAIN" ? (
                      <li
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                     ${selectAll ? "bg-label-info" : ""} hover-group`}
                        onClick={() => handleSelectAll()}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <i className="ng ng-ng-customers-icon me-2 fs-6"></i>
                            <h6
                              className={`mb-0 fw-400 ${
                                selectAll ? "text-primary" : ""
                              }`}
                            >
                              All Supplier
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <i className="bx bx-chevron-right font-20"></i>
                          </h6>
                        </div>
                      </li>
                    ) : (
                      <li
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                     ${selectMy ? "bg-label-info" : ""} hover-group`}
                        onClick={() => handleSelectMy()}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <i className="ng ng-ng-customers-icon me-2 fs-6"></i>
                            <h6
                              className={`mb-0 fw-400 ${
                                selectMy ? "text-primary" : ""
                              }`}
                            >
                              My Supplier
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <i className="bx bx-chevron-right font-20"></i>
                          </h6>
                        </div>
                      </li>
                    )}
                    {groupName?.map((item) => (
                      <li
                        key={item._id}
                        className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border
                      ${
                        selectedGroupId === item?._id ? "bg-label-info " : ""
                      } hover-group`}
                        onClick={() => {
                          setCurrentPage(0);
                          handleGroupCustomerList(item);
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <div className="d-flex align-items-center mx-2 flex-grow-1">
                            <i className="ng ng-ng-customers-icon me-2 fs-6"></i>
                            <h6
                              className={`mb-0 fw-400 text-break ${
                                selectedGroupId === item?._id
                                  ? "text-primary"
                                  : ""
                              }`}
                            >
                              {item?.name}
                            </h6>
                          </div>
                        </div>
                        <div className="ms-auto">
                          <h6 className="mb-0">
                            <i className="bx bx-chevron-right font-20"></i>
                          </h6>
                        </div>
                      </li>
                    ))}
                    {listWallet?.map((item) => (
                        <li
                          key={item?._id}
                          className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border ${
                            selectedWalletId === item?._id
                              ? "bg-label-info "
                              : ""
                          }`}
                          onClick={() => handleViewRechargeWallet(item._id)}
                        >
                          <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center mx-2 flex-grow-1">
                              <i className="bx bx-wallet-alt me-2 fs-5"></i>
                              <h6
                                className={`mb-0 fw-400 ${
                                  selectedWalletId === item?._id
                                    ? "text-primary"
                                    : ""
                                }`}
                              >
                                {item?.walletname} (
                                <span>
                                  {CurrencyConverter.toCurrency(
                                    item?.walletbalance || 0,
                                    "INR"
                                  )}
                                </span>
                                )
                              </h6>
                            </div>
                          </div>
                          <div className="ms-auto">
                            <h6 className="mb-0">
                              <i className="bx bx-chevron-right font-20"></i>
                            </h6>
                          </div>
                        </li>
                      ))}
                  </ul>
                  {isUser.stype === "MAIN" && (
                    <div className="row g-3 pt-2">
                      <div className="col-lg-12">
                        <Button
                          text="New Group"
                          icon="ng ng-ng-add-icon"
                          bgColor="bg-label-infos"
                          textColor="text-white"
                          className="text-right w-100"
                          onClick={handleNewGroupOpen}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div> */}
          <div className="col-12 col-lg-12">
            <div className="page-breadcrumb d-flex align-items-center paddingBottom">
              <div className="d-flex align-items-center pe-3">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isLoading ? "bx-spin" : ""}`}/>
                  </button>
                </div>
                <span className="breadcrumb-title">Supplier </span>
                {!selectedGroupDetails?._id && (
                  <div className="col-lg-12 ms-3">
                    <div className="position-relative">
                      <div className="input-group" ref={customerSuggestionsRef}>
                        <input
                          type="text"
                          className="form-control"
                          ref={searchInputRef}
                          onChange={(e) => {
                            handleSearch(e.target.value);
                            setActiveIndex(-1);
                          }}
                          onKeyDown={handleSuggestionNavigation}
                          autoComplete="off"
                          placeholder="Search supplier by name, phone, email..."
                        />
                        <button
                          className="input-group-text"
                          onClick={handleSearchFind}
                        >
                          <SearchIcon/>
                        </button>
                      </div>

                      {hasSearched &&
                        isSearchTerm &&
                        !suggestionLoading &&
                        customerSuggestions.length === 0 && (
                          <ul className="suggestions-list">
                            <li className="suggestion-item text-muted">
                              No Suppliers data was found
                            </li>
                          </ul>
                        )}

                      {customerSuggestions.length > 0 && (
                        <ProductSearchList
                          suggest={customerSuggestions}
                          suggestionRefs={suggestionRefs}
                          handleSelect={handleSelectCustomer}
                          activeIndex={activeIndex}
                          type="customer"
                        />
                      )}
                    </div>
                  </div>
                  // <>
                  //   -{" "}
                  //   <span
                  //     className="ms-1 d-flex align-items-center justify-content-between badge rounded-10 bg-label-info cursor-poInter p-2"
                  //     onClick={() => handleEditGroupOpen()}
                  //   >
                  //     <span className="me-2">
                  //       <i className="ng ng-ng-customers-icon fs-6"></i>
                  //     </span>
                  //     <span className="text-primary">
                  //       {selectedGroupDetails?.name}
                  //     </span>
                  //     <span className="ms-2">
                  //       <i className="ng ng-ng-edit-icon"></i>
                  //     </span>
                  //   </span>
                  // </>
                )}
              </div>

              <div className="ms-auto d-flex gap-2">
                {uRLs.SUPPLIER_BULK_UPLOAD === "true" && (
                  <div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={handleLink}
                    >
                      <UploadIcon/> Bulk Upload
                    </button>
                  </div>
                )}
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-export dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <DownloadIcon/> Export
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" onClick={exportToCSV}>
                        <SpreadSheetIcon/>{" "}
                        <span className="icon-text">Excel (CSV)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col">
                <div className="card radius-10 mb-0">
                  <div className="card-body px-0">
                    <div className="row px-3">
                      {selectedGroupDetails?._id && (
                        <div className="col-lg-6 col-12">
                          <>
                            <div className="d-flex align-items-center">
                              <span className="d-flex align-items-center ">
                                <span
                                  className="ms-1 d-flex align-items-center justify-content-between badge rounded-10 bg-label-info cursor-poInter p-2"
                                  onClick={() => handleEditGroupOpen()}
                                >
                                  <span className="me-2">
                                    <CustomersIcon iClass={"fs-6"}/>
                                  </span>
                                  <span className="text-primary text-truncate fs-15">
                                    {selectedGroupDetails?.name}
                                  </span>
                                  <span className="ms-2">
                                    <EditIcon/>
                                  </span>
                                </span>
                                <span className="ms-1">-</span>
                                <span className="badge btn-label-primary fs-15 ms-1">
                                  {totalItems || 0}
                                </span>
                              </span>
                              <div
                                className="input-group ms-3"
                                style={{ width: "50%" }}
                              >
                                <span className="input-group-text">
                                  <SortDownIcon/>
                                </span>
                                <select
                                  className="form-select"
                                  onChange={handleFilterChange}
                                  value={`${selectedFilter.field}-${selectedFilter.order}`}
                                >
                                  <option value="createdAt-desc">
                                    Added On (Newest)
                                  </option>
                                  <option value="createdAt-asc">
                                    Added On (Oldest)
                                  </option>
                                  <option value="normalizedName-asc">
                                    Name (A-Z)
                                  </option>
                                  <option value="normalizedName-desc">
                                    Name (Z-A)
                                  </option>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId",
                                  ) && (
                                    <>
                                      <option value="referenceid-asc">
                                        Reference No (Asc)
                                      </option>
                                      <option value="referenceid-desc">
                                        Reference No (Desc)
                                      </option>
                                    </>
                                  )}
                                </select>
                              </div>
                            </div>
                          </>
                        </div>
                      )}
                      {!selectedGroupDetails?._id && (
                        <div className="col-lg-6 col-12">
                          <>
                            <div className="d-flex align-items-center">
                              <span
                                className="ms-1 d-flex align-items-center justify-content-between badge rounded-10 bg-label-supplier cursor-poInter p-2"
                                // onClick={() => handleEditGroupOpen()}
                              >
                                <span className="me-2">
                                  <CustomersIcon iClass={"fs-6"}/>
                                </span>
                                <span className=" text-truncate fs-15">
                                  {isUser.stype === "MAIN"
                                    ? "All Supplier"
                                    : "My Supplier"}
                                </span>
                                {/* <span className="ms-2">
                                  <i className="ng ng-ng-edit-icon"></i>
                                </span> */}
                              </span>
                              <span className="ms-1">-</span>
                              <span className="badge btn-label-primary fs-15 ms-1">
                                {totalItems || 0}
                              </span>
                              <div
                                className="input-group ms-3"
                                style={{ width: "50%" }}
                              >
                                <span className="input-group-text">
                                  <SortDownIcon/>
                                </span>
                                <select
                                  className="form-select"
                                  onChange={handleFilterChange}
                                  value={`${selectedFilter.field}-${selectedFilter.order}`}
                                >
                                  <option value="createdAt-desc">
                                    Added On (Newest)
                                  </option>
                                  <option value="createdAt-asc">
                                    Added On (Oldest)
                                  </option>
                                  <option value="normalizedName-asc">
                                    Name (A-Z)
                                  </option>
                                  <option value="normalizedName-desc">
                                    Name (Z-A)
                                  </option>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId",
                                  ) && (
                                    <>
                                      <option value="referenceid-asc">
                                        Reference No (Asc)
                                      </option>
                                      <option value="referenceid-desc">
                                        Reference No (Desc)
                                      </option>
                                    </>
                                  )}
                                </select>
                              </div>
                            </div>
                          </>
                        </div>
                      )}
                      {/* {!selectedGroupDetails?._id && (
                        <div className="col-lg-3  col-6 d-flex align-items-center ms-0">
                          <div>
                            <strong>Total Customers: </strong>

                            <span className="badge btn-label-primary fs-15 ms-1">
                              {totalItems || 0}
                            </span>
                          </div>
                        </div>
                      )} */}
                      {/* <div className="col-lg-3 col-12 mb-2 mb-lg-0">
                        <div className="input-group">
                          <span className="input-group-text">
                            <i className="bx bx-sort-down"></i>
                          </span>
                          <select
                            className="form-select"
                            onChange={handleFilterChange}
                            value={`${selectedFilter.field}-${selectedFilter.order}`}
                          >
                            <option value="createdAt-asc">
                              Created At (Asc)
                            </option>
                            <option value="createdAt-desc">
                              Created At (Desc)
                            </option>
                            {viewOption(
                              "customerSettings",
                              "isReferenceId"
                            ) && (
                              <>
                                <option value="referenceid-asc">
                                  Reference No (Asc)
                                </option>
                                <option value="referenceid-desc">
                                  Reference No (Desc)
                                </option>
                              </>
                            )}
                          </select>
                        </div>
                      </div> */}

                      <div className="col-lg-1 col-6 "></div>
                      <div className="col-lg-5 col-6 d-flex justify-content-end">
                        <button
                          type="button"
                          onClick={handleOpenModal}
                          className="btn btn-jobcard mt-2 mt-lg-0"
                        >
                          <AddIcon/> Add Supplier
                        </button>
                      </div>
                    </div>
                    <>
                      <div className="table-responsive mt-3">
                        <table className="table align-middle mb-0">
                          <thead className="table-light text-center">
                            <tr>
                              <th>S.No</th>
                              {viewOption(
                                "customerSettings",
                                "isReferenceId",
                              ) && <th>Reference No</th>}
                              <th>Name</th>
                              <th>Number</th>
                              <th>Email</th>
                              {/* <th>State</th>
                              <th>Pincode</th> */}
                              <th>GST Number</th>
                              {/* <th>Status</th> */}
                              {/* <th>Actions</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading ? (
                              [...Array(9)].map((_, index) => (
                                <tr key={index}>
                                  {[...Array(totalSkeletonColumns)].map(
                                    (__, i) => (
                                      <td key={i} className="text-center">
                                        <Skeleton
                                          variant="text"
                                          width={i === 0 ? 200 : 200}
                                        />
                                      </td>
                                    ),
                                  )}
                                </tr>
                              ))
                            ) : isCustomerData.length > 0 ? (
                              isCustomerData.map((item, index) => (
                                <tr
                                  key={item._id || index}
                                  className="position-relative  cursor-poInter hover-row"
                                  onClick={() => handleView(item)}
                                  role="button"
                                  data-item={JSON.stringify(item)}
                                >
                                  <td className="text-center paddingTopBottom">
                                    {/* {currentPage * perPage + index + 1} */}
                                    {totalItems -
                                      (currentPage * perPage + index)}
                                    {/* {isCustomerData.length - index} */}
                                    {item.status === "ACTIVE" ? (
                                      <span className="rounded fsz-10 ms-1">
                                        <CircleIcon iClass={"text-success"}/>
                                      </span>
                                    ) : (
                                      <span className="rounded fsz-10 ms-1">
                                        <CircleIcon iClass={"text-light-gray"}/>
                                      </span>
                                    )}
                                  </td>
                                  {viewOption(
                                    "customerSettings",
                                    "isReferenceId",
                                  ) && (
                                    <td className="text-center">
                                      {item?.referenceid || "-"}
                                    </td>
                                  )}
                                  <td className="text-center">{item?.name}</td>
                                  <td className="text-center text-heading fw-medium">
                                    {item.number}
                                  </td>
                                  <td className="text-center">
                                    {item?.email || "-"}
                                  </td>
                                  {/* <td className="text-center">
                                    {item?.state || "-"}
                                  </td>
                                  <td className="text-center">
                                    {item?.pincode || "-"}
                                  </td> */}
                                  <td className="text-center w-15">
                                  <div className="no-print position-relative">
                                   <div className=" d-flex justify-content-center align-items-center">
                                    <span className="stock-status-badge">{item?.gstnumber || "-"}</span>
                                    <div className="order-actions order-actions3 opacity-0 opacity-md-100">
                                      <button
                                        type="button"
                                        className="btn-label-info shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleView(item)}
                                        }
                                      >
                                        <ShowIcon/>
                                      </button>
                                      </div>
                                    </div>
                                    </div>
                                  </td>
                                  {/* <td className="text-center">
                                {item.status && (
                                  <span
                                    className={`badge rounded-pill ${getColor(
                                      item.status
                                    )}`}
                                  >
                                    {item.status.charAt(0).toUpperCase() +
                                      item.status.slice(1).toLowerCase()}
                                  </span>
                                )}
                              </td> */}
                                  {/* <td className="text-center">
                                    <div className="order-actions opacity-0 opacity-md-100">
                                      <button
                                        type="button"
                                        className="btn-label-info shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleView(item)}
                                        }
                                      >
                                        <i className="bx bx-show"></i>
                                      </button>
                                      <button
                                        type="button"
                                        className="btn-label-primary shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openEditModal(item)}
                                        }
                                      >
                                        <i className="ng ng-ng-edit-icon"></i>
                                      </button>

                                      <button
                                        type="button"
                                        className="btn-label-danger shadow-none me-2"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openDeleteModal(item)
                                        }}
                                      >
                                        <i className="ng ng-ng-delete-icon"></i>
                                      </button>
                                    </div>
                                  </td> */}
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="9"
                                  className="text-center p-2 text-muted"
                                >
                                  <span className="text-muted">
                                    No suppliers found in the store. add some
                                    suppliers to get started.
                                  </span>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {totalPages > 0 && (
                        <div className="d-flex justify-content-center mt-3">
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setIsLoading(true);
                              setCurrentPage(selected);
                              if (selectedGroupId) {
                                // handleGroupCustomerList(
                                //   selectedGroupDetails,
                                //   selected,
                                //   selectedFilter.field,
                                //   selectedFilter.order
                                // );
                              } else {
                                handleListCustomer(
                                  selected,
                                  isSearchTerm,
                                  selectedFilter.field,
                                  selectedFilter.order,
                                );
                              }
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        </div>
                      )}
                    </>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AddSupplier
          isActive={isActive}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onAdd={handleAdd}
          isBtnLoading={isBtnLoading}
          groupId={selectedGroupId}
          selectedGroupDetails={selectedGroupDetails}
          // onEditGroupData={handleCustomerGroupEdit}
          groupName={groupName}
          // onChangeGroup={handleGroupChange}
          // onNewGroupsIn={handleCustomerGroupAdd}
          newGroup={newGroupName}
          error={error}
          setErrors={setErrors}
          numberSuggest={numberSuggest}
          addNewCustomNumber={addNewCustomNumber}
        />
        {isViewModalOpen && (
          <CustomerView
            isActive={isActive}
            isOpen={isViewModalOpen}
            onClose={() => setViewModalOpen(false)}
            supplierId={selectedCustomerId}
            onUpdate={hanleUpdateCustomer}
            OnDelete={handleDeleteCustomer}
            groupId={selectedGroupId}
            selectedGroupDetails={selectedGroupDetails}
            // onEditGroupData={handleCustomerGroupEdit}
            // onChangeGroup={handleGroupChange}
            setCustomerData={setCustomerData}
            setCustTotalItems={setTotalItems}
            onNewGroupsSet={handleNewGroupSet}
          />
        )}

        {isEditModalOpen && (
          <EditSupplier
            editData={isEditData}
            onClose={closeEditModal}
            onEdit={handleUpdte}
            isBtnLoading={isBtnLoading}
            groupId={selectedGroupId}
            selectedGroupDetails={selectedGroupDetails}
            // onEditGroupData={handleCustomerGroupEdit}
            groupName={groupName}
            // onChangeGroup={handleGroupChange}
            // onNewGroupsIn={handleCustomerGroupAdd}
            newGroup={newGroupName}
            error={error}
            setErrors={setErrors}
          />
        )}

        {isDeleteModalOpen && (
          <DeleteModal
            onClose={() => setDeleteModalOpen(false)}
            onConfirm={handleDelete}
            isLable={" Supplier " + isDeleteData?.name}
            isBtnLoading={isBtnLoading}
          />
        )}
        {addNewGroupOpen && (
          <AddGroup
            onClose={handleNewGroupClose}
            // onNewGroupIn={handleCustomerGroupAdd}
            isBtnLoading={addGroupload}
          />
        )}
        {editGroupOpen && (
          <EditGroup
            onClose={handleEditGroupClose}
            // onNewGroupIn={handleCustomerGroupEdit}
            isBtnLoading={addGroupload}
            onData={selectedGroupDetails}
          />
        )}
      </div>
    </div>
  );
};

export default Supplier;
